import React, { useEffect } from "react";
import styled from "styled-components";
import Drawing from "@/drawing";

const FlipBookContainer = styled.div`
  position: absolute;
  left: 127px;
  width: 1670px;
  height: 830px;
  top: 186px;
  transform-origin: 0 0;
  transform: scale(1);
  overflow: hidden;

  .shadow {
    box-shadow: 3px 10px 0px 4px rgba(0, 0, 0, 0.2);
  }
  animation: fadeIn 1s;
  z-index: 5;

  #flipbook {
    pointer-events: none;
  }

  .first-cover {
    &:first-child {
      &:after {
        content: "";
        position: absolute;
        right: calc(30px * var(--stage-per));
        bottom: calc(30px * var(--stage-per));
        width: calc(144px * var(--stage-per));
        height: calc(144px * var(--stage-per));
        background: url(${require("@assets/img/icon_book_cover.png")}) no-repeat;
        background-size: 100% 100%;
        z-index: 5;
        pointer-events: none;
      }
    }
  }
`;
const CanvasWrap = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
`;

const FlipBook = ({ pages }) => {
  useEffect(() => {
    return () => {
      Drawing.destroy();
    };
  }, []);

  return (
    <FlipBookContainer id="flipbook_container">
      <div id="flipbook">
        {pages.map((data, i) => {
          return (
            <div className={i === 0 ? "page first-cover" : "page"} key={i}>
              <img src={data.book} alt="" />
            </div>
          );
        })}
      </div>
      <CanvasWrap id="drawStage" className="draw-wrap"></CanvasWrap>
    </FlipBookContainer>
  );
};
export default React.memo(FlipBook);
